import { StreamItem } from '../data/streamFeed';

/**
 * StreamCard — одно сохранённое сообщение в чате "Избранное".
 * Поддерживает многострочные тексты через whitespace-pre-line —
 * нужно для рецептов и заметок с переносами.
 */
export default function StreamCard({ item }: { item: StreamItem }) {
  return (
    <div className="flex items-end gap-2.5">
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center font-display font-semibold text-white text-xs shrink-0 mb-0.5"
        style={{ backgroundColor: item.senderColor }}
        aria-hidden
      >
        {item.senderInitial}
      </div>

      <div className="flex-1 min-w-0 max-w-[300px]">
        <div className="font-body text-[#7a8a79] text-[11px] mb-1 ml-1.5 truncate">
          {item.senderName}
        </div>
        <div className="relative">
          <div
            className="bg-white rounded-2xl rounded-bl-md px-3.5 py-2.5 border border-[#e7f0e5]"
            style={{ boxShadow: '0 4px 12px -4px rgba(20,40,20,0.10)' }}
          >
            <span className="font-body text-[#161d16] text-[14px] leading-snug block whitespace-pre-line">
              {item.text}
            </span>
          </div>
          <span
            className="absolute -top-2 -right-1.5 w-5 h-6 bg-[#b7102a] flex items-center justify-center"
            style={{
              boxShadow: '0 2px 6px rgba(183,16,42,0.35)',
              clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 75%, 0 100%)',
              borderRadius: '3px 3px 0 0',
            }}
            aria-label="сохранено в избранном"
          >
            <svg width="9" height="9" viewBox="0 0 24 24" fill="white" className="-mt-1">
              <path d="M5 3a2 2 0 0 0-2 2v17l9-5 9 5V5a2 2 0 0 0-2-2H5z" />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
}
